"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

import { setCookie } from "@/services/CookiesService";
import { ProviderIdentifier } from "@/containers/PaymentContainer/PaymentProviderFactory/types";
import { VALID_PSP_VALUES } from "@/internals/constants/psp";

import { PSP } from "./types";

export const StorePsp = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const pspParam = searchParams.get("psp");

    if (pspParam) {
      const pspLowerCase = pspParam.toLowerCase();
      if (VALID_PSP_VALUES.includes(pspLowerCase as ProviderIdentifier)) {
        setCookie(PSP, pspLowerCase);
      }
    }
  }, [searchParams]);

  return null;
};
